import { groupRecipe } from "./group.styles.js";
import { c } from "react/compiler-runtime";
import { jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
//#region src/components/layout/group/group.tsx
/**
* Group arranges items on a horizontal axis with semantic gap,
* alignment, wrapping, and distribution controls.
*/
var Group = (t0) => {
	const $ = c(16);
	let className;
	let otherProps;
	let t1;
	let t2;
	let t3;
	let t4;
	if ($[0] !== t0) {
		({gap: t1, align: t2, justify: t3, wrap: t4, className, ...otherProps} = t0);
		$[0] = t0;
		$[1] = className;
		$[2] = otherProps;
		$[3] = t1;
		$[4] = t2;
		$[5] = t3;
		$[6] = t4;
	} else {
		className = $[1];
		otherProps = $[2];
		t1 = $[3];
		t2 = $[4];
		t3 = $[5];
		t4 = $[6];
	}
	const gap = t1 === void 0 ? "md" : t1;
	const align = t2 === void 0 ? "center" : t2;
	const justify = t3 === void 0 ? "start" : t3;
	const wrap = t4 === void 0 ? false : t4;
	let t5;
	if ($[7] !== align || $[8] !== className || $[9] !== gap || $[10] !== justify || $[11] !== wrap) {
		t5 = clsx(groupRecipe({
			gap,
			align,
			justify,
			wrap: wrap ? "wrap" : "nowrap"
		}), className);
		$[7] = align;
		$[8] = className;
		$[9] = gap;
		$[10] = justify;
		$[11] = wrap;
		$[12] = t5;
	} else t5 = $[12];
	let t6;
	if ($[13] !== otherProps || $[14] !== t5) {
		t6 = /* @__PURE__ */ jsx("div", {
			className: t5,
			...otherProps
		});
		$[13] = otherProps;
		$[14] = t5;
		$[15] = t6;
	} else t6 = $[15];
	return t6;
};
//#endregion
export { Group };
